export const RegisterPerson = `        
        mutation RegisterPerson ($input: RegisterPersonInput!)  {
            registerPerson (input: $input) {
                clientMutationId
                jwtToken
            }
        }
`
